/**
 * Initialisation of Voyage page
 * Loads page for Voyage and events for a vessel.
 *
 * Some mixure between old (prototype) and new pattern (Revealing Module Pattern).
 * This include add log entries, display validations, save, load, fetch.
 *
 * TODO: Split up prototypal behaviour into views and manager/services.
 *       Everything add, remeove, rendering of dom should be moved to view
 *       Load/Save/Fetch => VRC.VoyageState
 *       DisplayValidation => VRC.ValidationSae
 *
 */


var VRC = VRC || {};

VRC.VoyageState = (function () {

	/**
	 * Initialize the Voyage page, submenu.
	 * If there are any voyage entries then load from local storage
	 * If not create a empty log entry and end voyage entry.
	 */

	var initVoyageLogPage = function () {
		var submenu = WELL.Handlebars.VRC.voyagelog_menu({});

		$('#menu_content').html(submenu);
		VRC.NavigationView.enable();

		showVoyageLogContainer();

		if (g_localsave_object.HasLocalStorageItem(G_LS_NAMES.VOYAGE_LOG)) {
			g_voyage_planning.LoadLogEntries(false);
		}
		else {
			g_voyage_planning.AddLogEntryAndAppendToDom();
			g_voyage_planning.AddEndVoyageLogEntry();
			g_voyage_planning.DisplayValidations();
		}

		VRC.CurrentVoyageView.init();
		VRC.VoyageLogTableView.init();

	};

	var getVoyageLogContainer = function () {
		return $('.voyagelog__wrapper');
	};

	var hideVoyageLogContainer = function () {
		getVoyageLogContainer().hide();
	};

	var showVoyageLogContainer = function () {
		getVoyageLogContainer().show();
	};

	var clearTable = function(){
		var $table = $('#event_log_table');
		$table.html('');
	};

	var render = function (voyageLogEntries) {
		var logEntryrows = [];

		clearTable();
		if (!voyageLogEntries) {
			voyageLogEntries = VRC.VoyageLogEntryManager.getAll();
		}

		_.each(voyageLogEntries, function (entry) {
            logEntryrows.push(g_voyage_planning.GetLogEntryRow(entry));
		});

        g_voyage_planning.appendLogEntryRowsToDOM(logEntryrows);

		g_voyage_planning.AddEndVoyageLogEntry();
	};

	var init = function () {
		VRC.CurrentVoyage.init();
		$('.voyagestart__wrapper').html('');

		if (VRC.CurrentVoyage.hasCurrentVoyage()) {
			initVoyageLogPage();
		}
		else {
			hideVoyageLogContainer();
			VRC.VoyageStartView.init();
		}
	};

	return {
		init: init,
		render : render
	}
})();

/*
 * Initialisation function for when voyage page is loaded
 */

function InitialiseVoyagePlanning () {
	VRC.VoyageState.init();
}

/*
 * Actions for when page is left
 */
function OnLeavingVoyagePage () {
	g_voyage_planning.SaveLogEntries();
}

/*
 * Menu selection
 */
function VoyageMenuSelect (p_select, p_calling_element) {
	var ACTIONS = {
		DELETE_LOG : 5
	};

	if (p_select == 1) {
		g_voyage_planning.AddLogEntryAndAppendToDom();
	}
	else if (p_select == 2) {

		g_voyage_planning.SaveLogEntries();
		VRC.ErrorHandleService.showMessage('Data for voyage log saved locally', G_MSG_TYPE_NORMAL);
	}
	else if (p_select == 3) {
		g_voyage_planning.LoadLogEntries();
		VRC.VoyageLogTableView.init();

	}
	else if (p_select == ACTIONS.DELETE_LOG) {
		var msg = 'This will remove all entries from list. Do you want to continue?';
		var onConfirm = function () {
			g_voyage_planning.ClearLocalStorage();
			g_voyage_planning.ClearLogEntries();
			g_voyage_planning.AddLogEntryAndAppendToDom();
			g_voyage_planning.AddEndVoyageLogEntry();
		};
		VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm})
	}
	else if (p_select == 6) {
		OpenSubmitDialog();
	}
	else if (p_select == 7) {
		g_voyage_planning.InsertLogEntry(p_calling_element);
	}
	else if (p_select == 8) {
		ConfirmFetchData();
	}
	else {

	}
	VRC.VoyageLogTableView.update();
}

function getPortsSelectList(e) {
    var selectizeElement= $(e).find('.log_entry_place').first();
    selectizeElement.selectize(VRC.Utils.Selectize.getConfig());
    var optionList = selectizeElement[0].selectize;
    var allPorts = VRC.MasterDataService.getGroupedPorts();
    var mappedKeys = {active: 'Active', rig: 'Rigs', port: 'Ports', position: 'Positions'}; 
    _.each(allPorts,
		function(group, key) {
        	optionList.addOption(_.map(group, function(element) {
        		return {value: element.id, text: element.name, optgroup: mappedKeys[key]}
        	}));
		}
	);
    e.onmouseenter = function(){};

}

function OpenVoyageInfoAndStartNewVoyage () {
	g_remote_object.FetchHTMLFromServer(g_voyage_planning, ParseWELSForm, 'info', 'voyage_info_end');
}

/*
 * Constructor for Voyage Planning State object
 */
function VoyagePlanning (p_log_table_name) {
	this.l_log_entries = {};

	this.l_table_name = p_log_table_name
	this.l_is_dirty = false;
};

/*
 * Loads any previously stored voyage validations
 */
VoyagePlanning.prototype.DisplayValidations = function () {

	$(".log_entry-warning").remove();
	var validations = g_localsave_object.GetLocalStorageItem(G_LS_NAMES.VOYAGE_VALIDATIONS);

	if (validations) {
		var hashSet = {};
		_.each(validations.voyage_log, function (voyageLogAlert) {
			if (voyageLogAlert.voyageLogId) {

				if (voyageLogAlert.message.indexOf('Voyage duration from') !== -1) { //End voyage events
					hashSet['end_voyage_entry'] = [voyageLogAlert];

				}

				else {
					var event = VRC.VoyageLogEntryManager.getEvent(voyageLogAlert.eventTypeId, voyageLogAlert.portId, voyageLogAlert.fromDate);
					if (event) {
						var eventId = event.getId();
						if (!hashSet[eventId]) {
							hashSet[eventId] = [];
						}
						hashSet[eventId].push(voyageLogAlert);
					}
				}

			}
		});

		_.each(hashSet, function (voyageAlertsOnDate, key) {

			var html = Handlebars.partials['event_log_warning'](voyageAlertsOnDate);

			$('#' + key).find('.log_event_type').before(html)
		});
	}
	$(".log_entry-warning").popover({html: true, sanitize: false });

	$('html').on('hidden.bs.popover', function (e) {
		$(e.target).data("bs.popover").inState.click = false;
	});

	$('html').on('click', function (e) {
		$('[data-original-title]').each(function () {
			//the 'is' for buttons that trigger popups
			//the 'has' for icons within a button that triggers a popup
			if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
				$(this).popover('hide');

			}
		});
	});
};

VoyagePlanning.prototype.AddLogEntryAndAppendToDom = function (p_params) {
	this.CreateDomLogEntry(this.AddLogEntry(p_params));
};

/*
 * Adds new log entry to the table
 */
VoyagePlanning.prototype.AddLogEntry = function (p_params) {

	var entry = VRC.VoyageLogEntry(p_params);
	VRC.VoyageLogEntryManager.add(entry);

	return entry;

};

VoyagePlanning.prototype.AddEndVoyageLogEntry = function () {
	var $table = $(this.l_table_name);

	var view = VRC.VoyageLogEntryEndView({});
	$table.append(view.getView());

};

/*
 * Creates a log entry.
 */
VoyagePlanning.prototype.CreateDomLogEntry = function (entry, $insertAfterObject) {
	var $l_table = $(this.l_table_name);
	var entryView = VRC.VoyageLogEntryView(entry);
	var $row = entryView.getView();

	if ($insertAfterObject) {
		$row.insertAfter($insertAfterObject);
	}
	else {
		$l_table.append($row);
	}
};

VoyagePlanning.prototype.GetLogEntryRow = function (entry) {
    var entryView = VRC.VoyageLogEntryView(entry);
    var $row = entryView.getView();

    return $row;
};

VoyagePlanning.prototype.appendLogEntryRowsToDOM = function (rows) {
	var $l_table = $(this.l_table_name);
	$l_table.html('<tbody></tbody>');
	var $l_tbody = $l_table.find('tbody');
    $l_tbody.append(rows);
};

/*
 * Checks if there is a previous entry and retrieves that location
 */
VoyagePlanning.prototype.GetPreviousPort = function () {
	var $l_entry = $(this.l_table_name).find('.log_entry').last();
	if ($l_entry === undefined) {
		return 0;
	}
	return $l_entry.find('.log_entry_place').val();
};

/*
 * Insert log entry
 */
VoyagePlanning.prototype.InsertLogEntry = function (p_calling_element) {
	var $l_parent = $(p_calling_element).closest('.log_entry');

	var inputData = {};
	if ($l_parent) {
		var previousEvent = VRC.VoyageLogEntryManager.getEventById($l_parent.attr('id'));
		if (previousEvent) {
			inputData.port = previousEvent.getPort();
			inputData.port_quay_id = previousEvent.getQuayId();
			inputData.dateTime = moment().local().format(g_timeStampFormat);
		}
	}
	var entry = VRC.VoyageLogEntry(inputData);
	VRC.VoyageLogEntryManager.add(entry);

	this.CreateDomLogEntry(entry, $l_parent);
};

/*
 * Clears all log entries in table
 */
VoyagePlanning.prototype.ClearLogEntries = function () {
	VRC.VoyageLogEntryManager.clear();
	$(this.l_table_name).find('.log_entry').remove();
	VRC.CurrentVoyageView.init();
};

/*
 * Clears all data (from localstorage
 */
VoyagePlanning.prototype.ClearLocalStorage = function () {
	this.ClearLogEntries();
	g_localsave_object.RemoveLocalStorageItem(G_LS_NAMES.VOYAGE_LOG);
	VRC.CurrentVoyage.onVoyageLogChange();
};

/*
 * Saves all log entries to local storage
 */
VoyagePlanning.prototype.SaveLogEntries = function () {

	var voyage = VRC.CurrentVoyage.getCurrentVoyage();
	voyage.save();
	VRC.VoyageLogEntryManager.save();

	VRC.CurrentVoyage.onVoyageLogChange();
};

/*
 * Loads all log entries from localstorage
 */
VoyagePlanning.prototype.LoadLogEntries = function (showMessage) {

	var entryJson = g_localsave_object.GetLocalStorageItem(G_LS_NAMES.VOYAGE_LOG) || [];

	if (!entryJson || entryJson.length === 0) {
		g_voyage_planning.AddLogEntry();
	}
	else {
		g_voyage_planning.ClearLogEntries();

		entryJson = _.sortBy(entryJson, function (element) {
			if (!element.dateTime) {
				element.dateTime = element.date || '' + ' ' + element.time || '';
			}
			return moment(element.dateTime, g_timeStampFormat).valueOf();
		});

		_.map(entryJson, function (entryArray) {
			return g_voyage_planning.AddLogEntry(entryArray);
		});



	}
	VRC.VoyageState.render();


	if (showMessage) {
		VRC.ErrorHandleService.showMessage('Data for voyage log loaded from local storage', G_MSG_TYPE_NORMAL);
	}

	VRC.VoyageLogTableView.refresh();
	VRC.VoyageLogTableView.update();
	VRC.CurrentVoyage.onVoyageLogChange();
	g_voyage_planning.DisplayValidations();
};

/*
 * Creates JSON object out of voyage log
 */
VoyagePlanning.prototype.CreateJSON = function () {
	var list = [];
	var logs = VRC.VoyageLogEntryManager.getAll();
	$.each(logs, function (key, log) {
		list.push(log.toJson());
	});
	return list;
};

/*
 * Callback function for parsing log data from database
 */
VoyagePlanning.prototype.ParseLogDataAndDisplay = function (p_owner, p_data) {
	p_owner.ClearLogEntries();
	g_voyage_planning.ParseLogData(p_owner, p_data);

	g_voyage_planning.DisplayValidations();
    VRC.CurrentVoyage.refresh();
};

/*
 * Callback function for parsing log data from database
 */
VoyagePlanning.prototype.ParseLogData = function (p_owner, p_data) {
	p_data = p_data || {};
	p_data.voyage_log = p_data.voyage_log || p_data;

	if (p_data === undefined || p_data == null) {
		return;
	}
	else if (p_data.voyage_log === undefined) {
		VRC.ErrorHandleService.showMessage('No log data was found. Most likely cause is that nothing has been submitted on the current journey', G_MSG_TYPE_WARNING);
		return;
	}

	VRC.VoyageLogEntryManager.clear();

	$.each(p_data.voyage_log, function (index, logData) {
		VRC.VoyageLogEntryManager.add(VRC.VoyageLogEntry(logData));
	});

	VRC.VoyageLogEntryManager.save();
};

/*
 * Fetches log entries from database
 */
VoyagePlanning.prototype.FetchLogEntries = function () {
	var isCurrentPage = (g_current_page === G_PAGE.VOYAGE_PAGE);

	var _this = this;
	var deferred = $.Deferred();

	if (isCurrentPage) {

		var onSucess = function (object, data) {
			_this.ParseLogDataAndDisplay(object, data);
			deferred.resolve(object, data);
		};

		g_remote_object.FetchDataFromServer(_this, onSucess, 'voyage_log', '');
	}
	else {
		var onSucess = function (object, data) {

			_this.ParseLogData(object, data);
			deferred.resolve(object, data);
		};

		g_remote_object.FetchDataFromServer(_this, onSucess, 'voyage_log', '');
	}

	return deferred.promise();
};





